import { createSelector } from '@ngrx/store';

import { onlineMenuVirtualLocationsState } from '../root';

export const getOnlineMenuVirtualLocations = createSelector(onlineMenuVirtualLocationsState, (onlineMenuVirtualLocations) => onlineMenuVirtualLocations);
